import MemberReminder from './MemberReminder';

export default MemberReminder;
